import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  AddState,
  GetAllState,
} from "../../../../../../../features/admin/masters/state/Slice";
import { AllCountry } from "../../../../../../../features/admin/common/Slice";

function Add_offcanvas({
  setShow,
  setSuccess,
  setErr,
  setShowError,
  defaultValues,
  showError,
  show,
  handleClose,
  setShowRejectModal,
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm({ defaultValues });
  const dispatch = useDispatch();
  const countries = useSelector((state) => state.common.all_country);

  useEffect(() => {
    dispatch(AllCountry());
  }, [dispatch]);
  const [modalSuccessShow, setModalsuccessShow] = useState(false);
  const countryOptions = [
    { value: "india", label: "India" },
    { value: "usa", label: "USA" },
    { value: "uk", label: "UK" },
    { value: "australia", label: "Australia" },
  ];

  // const onSubmit = async (data) => {
  //   try {
  //     const res = await dispatch(AddState(data));
  //     if (res.meta?.requestStatus === "fulfilled") {
  //       dispatch(GetAllState());
  //       setShow(false);
  //       setSuccess(true);
  //     } else if (res.meta?.requestStatus === "rejected") {
  //       console.log(
  //         res.payload?.response?.data?.errors,
  //         "res.payload?.response?.data?.errors"
  //       );

  //       setShowError(res.payload?.response?.data?.errors);
  //     }
  //   } catch (error) {
  //     setShow(false);
  //     setErr(true);
  //     console.error(error);
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(AddState(data));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAllState());

        setModalsuccessShow(true); // SHOW SUCCESS MODAL

        reset(); // optional
        setShow(false); // close offcanvas
        setSuccess(true); // parent success flag (optional)
      } else if (res.meta?.requestStatus === "rejected") {
        setShowError(res.payload?.response?.data?.errors);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);

      setErr(true);
      console.error(error);
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Country Selection Dropdown */}
                <Form.Group className="mb-3">
                  <Form.Label>Country</Form.Label>
                  <Controller
                    name="country_id"
                    control={control}
                    rules={{ required: "Country is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={countries}
                        onInputChange={(val) => {
                          dispatch(AllCountry(val));
                        }}
                      />
                    )}
                  />
                  {errors?.country_id && (
                    <Form.Text className="text-danger">
                      {errors?.country_id?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                        maxLength: {
                          value: 100,
                          message: "Name cannot exceed 100 characters",
                        },
                        pattern: {
                          value: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
                          message:
                            "Name should contain only letters and single spaces (no leading or trailing spaces)",
                        },
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Add_offcanvas;
